module.exports = __webpack_public_path__ + "static/media/leavemanagment.4fb796a7.svg";